<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 10.238 10.238">
    <path
      id="edit-tools"
      d="M8.712.367A1.355,1.355,0,0,0,6.8.367L6.317.849l-5.1,5.1L1.2,5.96s0,.005-.005.005-.014.016-.019.024,0,0,0,.005l-.014.022s0,.005-.005.008l-.008.022s0,0,0,.005L.014,9.457a.267.267,0,0,0,.065.276.273.273,0,0,0,.192.079A.32.32,0,0,0,.358,9.8l3.4-1.135s0,0,.005,0A.1.1,0,0,0,3.79,8.65l.006,0,.027-.016.024-.019s.005,0,.005-.005.008-.005.011-.011L9.446,3.013a1.355,1.355,0,0,0,0-1.915ZM3.674,8.027,1.788,6.142,6.507,1.423,8.392,3.309ZM1.523,6.643,3.17,8.29.7,9.113ZM9.064,2.634l-.287.29L6.892,1.039l.29-.29a.813.813,0,0,1,1.148,0l.737.737A.815.815,0,0,1,9.064,2.634Zm0,0"
      transform="translate(0.154 0.27)"
    />
  </svg>
</template>
<script>
export default {
  name: "M4EditSvg"
};
</script>
